import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { LanguageProvider } from './shell/language-context';
import { ThemeProvider } from './shell/theme-context';
import { SettingsProvider } from './shell/settings-context';
import { FavoritesProvider } from './shell/favorites-context';
import './theme/theme.css';
import './theme/motion.css';

import { brandArt } from './theme/tokens';
import { reloadOnStaleChunk } from './shell/reload-on-stale-chunk';

// SPA entry. The router owns all screens; LanguageProvider holds the en/bn choice
// consumed by every screen via the i18n dictionary (packages/i18n, DR-16).
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

// Favicon comes from the theme bundle, not index.html — the filename is a brand
// literal, and theme/ is the only place INF-1 permits one.
const favicon = document.createElement('link');
favicon.rel = 'icon';
favicon.type = 'image/png';
favicon.href = brandArt.icon;
document.head.appendChild(favicon);

// A tab left open across a deploy reloads instead of failing on a removed chunk.
reloadOnStaleChunk();

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <LanguageProvider>
      <SettingsProvider>
      <FavoritesProvider>
        <RouterProvider router={router} />
      </FavoritesProvider>
      </SettingsProvider>
      </LanguageProvider>
    </ThemeProvider>
  </StrictMode>,
);
